import { collection, doc, getDoc, setDoc } from 'firebase/firestore';
import { ITransactionOpportunity } from '../sp-types/transactionOpportunityType';
import { db } from './firebase';

const COLLECTION = 'transaction-back-test';

export async function getTransactionsById(accountId: string): Promise<ITransactionOpportunity[] | null> {
  const docRef = doc(db, COLLECTION, accountId);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data()?.transactions as ITransactionOpportunity[];
  }
  console.log('No matching documents found.');
  return null;
}

export async function createTransaction(
  accountId: string,
  transaction: ITransactionOpportunity[],
): Promise<{ uuid: string; status: string } | null> {
  try {
    const futureOrdersCollection = collection(db, COLLECTION);
    const docRef = doc(futureOrdersCollection, accountId);

    // Wrapping the array in an object before saving it
    await setDoc(docRef, { transactions: transaction }, { merge: true });
    console.log('Document written with ID: ', docRef.id);

    return { uuid: docRef.id, status: 'success' };
  } catch (e) {
    console.error('Error adding document: ', e);
    return { uuid: '', status: 'error' };
  }
}
